import * as types from './types'
import moment from 'moment'

export default {
  [types.RESET_ANALYSIS_DATA](state, data) {
    switch (data.name) {
      case 'all':
        state.activityProgress = []
        state.bodyfatProgress = []
        state.bodyweightProgress = []
        state.challengeProgress = []
        state.membershipProgress = []
        state.nutritionProgress = []
        break
      case 'activity':
        state.activityProgress = []
        break
      case 'bodyfat':
        state.bodyfatProgress = []
        break
      case 'bodyweight':
        state.bodyweightProgress = []
        break
      case 'challenge':
        state.challengeProgress = []
        break
      case 'membership':
        state.membershipProgress = []
        break
      case 'nutrition':
        state.nutritionProgress = []
        break
      case 'dashboard':
        state.dashboardProgress = []
        break
    }
  },
  [types.SET_ANALYSIS_DATA](state, data) {
    switch (data.name) {
      case 'selectedOrg': {
        state.analysis.selectedOrg = data.value
        break
      }
      case 'orgId': {
        state.analysis.orgId = data.value
        break
      }
      case 'challengeId': {
        state.analysis.challengeId = data.value
        break
      }
      case 'evalOption': {
        state.analysis.evalOption = data.value
        state.analysis.numWeeks = 1
        if (data.value === 'pastMonth') {
          state.analysis.startDate = moment()
            // .startOf('month')
            .startOf('week')
            .subtract(30, 'days')
            .add(1, 'days')
            .format('YYYY-MM-DD')
          state.analysis.endDate = moment()
            // .startOf('month')
            .startOf('week')
            .add(1, 'days')
            .format('YYYY-MM-DD')
        } else if (data.value === 'pastQtr') {
          state.analysis.startDate = moment()
            // .startOf('month')
            .startOf('week')
            .subtract(90, 'days')
            .add(1, 'days')
            .format('YYYY-MM-DD')
          state.analysis.endDate = moment()
            // .startOf('month')
            .startOf('week')
            .add(1, 'days')
            .format('YYYY-MM-DD')
        } else if (data.value === 'pastYear') {
          state.analysis.startDate = moment()
            // .startOf('month')
            .subtract(365, 'days')
            .startOf('week')
            .add(1, 'days')
            .format('YYYY-MM-DD')
          state.analysis.endDate = moment()
            // .startOf('month')
            .startOf('week')
            .add(1, 'days')
            .format('YYYY-MM-DD')
        } else if (data.value === 'numWeeks') {
          state.analysis.startDate = moment()
            .startOf('week')
            .add(1, 'days')
            .subtract(data.value, 'weeks')
            .format('YYYY-MM-DD')
          state.analysis.endDate = moment()
            .startOf('week')
            .add(1, 'days')
            .format('YYYY-MM-DD')
        } else if (data.value === 'dateRange') {
          state.analysis.startDate = moment()
            .startOf('week')
            .add(1, 'days')
            .subtract(1, 'week')
            .format('YYYY-MM-DD')
          state.analysis.endDate = moment()
            .startOf('week')
            .add(1, 'days')
            .format('YYYY-MM-DD')
        }
        break
      }
      case 'numWeeks': {
        state.analysis.numWeeks = data.value
        state.analysis.endDate = moment()
          .startOf('week')
          .add(1, 'days')
          .format('YYYY-MM-DD')
        state.analysis.startDate = moment()
          .startOf('week')
          .add(1, 'days')
          .subtract(data.value, 'weeks')
          .format('YYYY-MM-DD')
        break
      }
      case 'startDate': {
        state.analysis.startDate = moment(data.value).format('YYYY-MM-DD')
        break
      }
      case 'endDate': {
        state.analysis.endDate = moment(data.value).format('YYYY-MM-DD')
        break
      }
      case 'search':
        state.analysis.search = data.value
        break
    }
    console.log('Set Analysis Data', state.analysis)
  },
  [types.SET_ACTIVITY_PROGRESS](state, data) {
    state.activityProgress = []
    state.members = []
    state.isAllChecked = false
    if (data !== undefined && data !== null) {
      state.activityProgress = data
      if (state.activityProgress) {
        state.activityProgress.forEach((element) => {
          let found = state.members.find(
            (x) => parseInt(x.user_id) === parseInt(element.user_id)
          )
          if (!found) {
            state.members.push({
              user_id: element.user_id,
              firstname: element.FirstName,
              lastname: element.LastName,
              name: `${element.FirstName} ${element.LastName}`,
            })
          }
        })
      }
    }
    console.log('Got Activity Progress', {
      activityProgress: state.activityProgress,
      members: state.members,
    })
  },
  [types.SET_BODYFAT_PROGRESS](state, data) {
    state.bodyfatProgress = []
    state.members = []
    state.isAllChecked = false
    if (data !== undefined && data !== null) {
      state.bodyfatProgress = data
      if (state.bodyfatProgress) {
        state.bodyfatProgress.forEach((element) => {
          let found = state.members.find(
            (x) => parseInt(x.user_id) === parseInt(element.user_id)
          )
          if (!found) {
            state.members.push({
              user_id: element.user_id,
              firstname: element.FirstName,
              lastname: element.LastName,
              name: `${element.FirstName} ${element.LastName}`,
            })
          }
        })
      }
    }
    console.log('Got Body Fat Progress', {
      bodyfatProgress: state.bodyfatProgress,
      members: state.members,
    })
  },
  [types.SET_BODYWEIGHT_PROGRESS](state, data) {
    state.bodyweightProgress = []
    state.members = []
    state.isAllChecked = false
    if (data !== undefined && data !== null) {
      state.bodyweightProgress = data
      if (state.bodyweightProgress) {
        state.bodyweightProgress.forEach((element) => {
          let found = state.members.find(
            (x) => parseInt(x.user_id) === parseInt(element.user_id)
          )
          if (!found) {
            state.members.push({
              user_id: element.user_id,
              firstname: element.FirstName,
              lastname: element.LastName,
              name: `${element.FirstName} ${element.LastName}`,
            })
          }
        })
      }
    }
    console.log('Got Body Weight Progress', {
      bodyweightProgress: state.bodyweightProgress,
      members: state.members,
    })
  },
  [types.SET_CHALLENGE_PROGRESS](state, data) {
    state.challengeProgress = []
    state.members = []
    state.isAllChecked = false
    if (data !== undefined && data !== null) {
      state.challengeProgress = data
      if (state.challengeProgress) {
        state.challengeProgress.forEach((element) => {
          let found = state.members.find(
            (x) => parseInt(x.user_id) === parseInt(element.user_id)
          )
          if (!found) {
            state.members.push({
              user_id: element.user_id,
              firstname: element.FirstName,
              lastname: element.LastName,
              name: `${element.FirstName} ${element.LastName}`,
            })
          }
        })
      }
    }
    console.log('Got Challenge Progress', {
      challengeProgress: state.challengeProgress,
      members: state.members,
    })
  },
  [types.SET_MEMBERSHIP_PROGRESS](state, data) {
    state.membershipProgress = []
    state.members = []
    state.isAllChecked = false
    if (data !== undefined && data !== null) {
      state.membershipProgress = data
    }
    console.log('Got Membership Progress', state.membershipProgress)
  },
  [types.SET_NUTRITION_PROGRESS](state, data) {
    state.nutritionProgress = []
    state.members = []
    state.isAllChecked = false
    if (data !== undefined && data !== null) {
      state.nutritionProgress = data
      if (state.nutritionProgress) {
        state.nutritionProgress.forEach((element) => {
          let found = state.members.find(
            (x) => parseInt(x.user_id) === parseInt(element.user_id)
          )
          if (!found) {
            state.members.push({
              user_id: element.user_id,
              firstname: element.FirstName,
              lastname: element.LastName,
              name: `${element.FirstName} ${element.LastName}`,
            })
          }
        })
      }
    }
    console.log('Got Nutrition Progress', {
      activityProgress: state.nutritionProgress,
      members: state.members,
    })
  },
  [types.SET_DASHBOARD_PROGRESS](state, data) {
    state.dashboardProgress = []
    state.members = []
    state.isAllChecked = false
    if (data !== undefined && data !== null) {
      state.dashboardProgress = data
      state.dashboardProgress.forEach((element) => {
        element.progressDate = moment(`${element.year}W${element.week}`).format(
          'YYYY-MM-DD'
        )
      })
      if (state.dashboardProgress) {
        state.dashboardProgress.forEach((element) => {
          let found = state.members.find(
            (x) => parseInt(x.user_id) === parseInt(element.user_id)
          )
          if (!found) {
            state.members.push({
              user_id: element.user_id,
              firstname: element.FirstName,
              lastname: element.LastName,
              name: `${element.FirstName} ${element.LastName}`,
            })
          }
        })
      }
    }
    console.log('Got Dashboard Progress', {
      activityProgress: state.dashboardProgress,
      members: state.members,
    })
  },
  [types.SET_CHECKED](state, data) {
    state.isAllChecked = true
    if (data.action === 'all') {
      state.members.forEach((element) => {
        element.checked = data.checked
      })
    } else if (data.action === 'member') {
      let found = state.members.find(
        (x) => parseInt(x.user_id) === parseInt(data.checked.user_id)
      )
      if (found) {
        found.checked = data.checked.checked
      }
    }
    for (let idx = 0; idx < state.members.length; idx++) {
      if (!state.members[idx].checked) {
        state.isAllChecked = false
        break
      }
    }
  },
}
